import axios from "axios";
// import store from '../store';

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}
export default {
  cekTerminKomplit(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const {
        //     data
        // } = await axios.get(`/procure/cekTerminKomplit/${obj.po}/${obj.termin}/${obj.kontrakKey || ''}`);

        const keys = ["po", "termin", "kontrakKey"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/procure/cekTerminKomplit${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  currency() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/currency/cbo");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  detail(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(
          `apunbill/detail/${oencodeURIComponent(bj.kontrakKey)}`
        );
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  paymenthistory(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(
          `apunbill/detailsettle/${encodeURIComponent(obj.kontrakKey)}`
        );
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportxls(obj = {}) {
    const keys = [
      "sortBy",
      "sortDir",
      "uraian",
      "DimCol",
      "DimColInfo",
      "DimVal",
      "tgl1",
      "tgl2",
      "outstand",
      "nomor",
      "invoice",
      "vendor",
      "vendorcode",
      "po",
      "postgroup",
      "posting",
      "tagihandp",
      "receivingposting",
    ];

    let str = "";
    for (const key in obj) {
      if (keys.indexOf(key) >= 0 && obj[key]) {
        str += str ? "&" : "?";
        str += key + "=" + encodeURIComponent(obj[key]);
      }
    }

    axios({
      url: `/apunbill/exportxls${str}`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "apunbill.xlsx");
      document.body.appendChild(link);
      link.click();
      // window.location.assign(url);
    });
  },
  findcoa(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(
          `coa/findcoa/${obj.kodeacc}/${obj.tahun}`
        );
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  getcoa(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  insert(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post("apunbill", obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  saveinfo(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post("apunbill/saveinfo", obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  savenpost(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // await axios.post("apunbill/savenpost", obj);
        const { data } = await axios.post("apunbill/savenpost", obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  list(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "page",
          "limit",
          "sortBy",
          "sortDir",
          "uraian",
          "DimCol",
          "DimVal",
          "tgl1",
          "tgl2",
          "outstand",
          "nomor",
          "invoice",
          "vendor",
          "vendorcode",
          "po",
          "postgroup",
          "posting",
          "tagihandp",
          "receivingposting",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/apunbill${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pasalpph() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/apunbill/pasalpph");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postgroup() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/apunbill/postgroup");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  prepaidexp() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/groupakun/prepaidexp");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  posting(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(
          `apunbill/posting/${encodeURIComponent(obj.kontrakKey)}`
        );
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingUndo(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(
          `apunbill/unposting/${encodeURIComponent(obj.kontrakKey)}`
        );
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        str = "?key=" + encodeURIComponent(obj.kontrakKey);
        url = `/apunbill/printjv`;

        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  remove(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(
          `apunbill/${encodeURIComponent(obj.kontrakKey)}`
        );
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
